/* global showSuccessToast */
/* global showInfoToast */
/* global showWarningToast */
/* global showDangerToast */
import React, { useState, useContext, useEffect } from "react";
import { AuthContext, AuthProvider } from './context/AuthContext';
import { SearchContext } from './layout/SearchContext';
import { getTargets, getTargetTypes, getCarriers, getUser, getUsers, getCurrency, updateContact, getContacts, addTargetItem, addContact, getTargetItems, updateTargetItemUnlocked, updateTargetItemStatus, getTargetItemsKO, sendMessage, getTargetSettings, getSettings } from "../api/api";
import { getParentID } from "../api/api";
import { addTargetCard, updateTargetCard } from "../api/api";
import Calendar from "./tools/Calendar";
import FooterBar from "./layout/FooterBar";
import Rightbar from "./layout/Rightbar";
import globals from '../config/globals.json'
import FooterButton from "./tools/FooterButton";

const Rewards = (props) => {
    const companyID = props.userDetails?.Company?.[0]?.dataID || null;
    const { user } = useContext(AuthContext);
    const [userDetails, setUserDetails] = useState(null);
    const [targetSettings, setTargetSettings] = useState(null);
    const [settings, setSettings] = useState(null);
    const [targetTypes, setTargetTypes] = useState([]);
    const [thresholds, setThresholds] = useState([{ points: "", typeId: "" }]);
    const [carriers, setCarriers] = useState([]);

    const [carrierFilter, setCarrierFilter] = useState("");
    const [valueFilter, setValueFilter] = useState("");
    const [typeFilter, setTypeFilter] = useState("");
    const { searchTerm, clearSearch } = useContext(SearchContext);
    const [sortOrder, setSortOrder] = useState("value-asc");
    const [currency, setCurrency] = useState("");
    const [customerType, setCustomerType] = useState("");

    const [listTargets, setListTargets] = useState([]);

    const [isEditable, setIsEditable] = useState(false);
    const [isDeletable, setIsDeletable] = useState(false);

    const loadUserDetails = async (user) => {
        const response = await getUser(user);
        setUserDetails(response.data.data.getUserListing.edges[0].node);
    };

    const itemStatus = {
        0: {
            name: "In lavorazione",
            color: "warning"
        },
        1: {
            name: "Completato",
            color: "success"
        },
        2: {
            name: "Annullato",
            color: "danger"
        }
    };

    const [targets, setTargets] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState(() => {
        const now = new Date();
        return now.toISOString().slice(0, 7); // "YYYY-MM"
    });

    // const [selectedMonth, setSelectedMonth] = useState(null);

    const [selectedDate, setSelectedDate] = useState(() => {
        const now = new Date();
        setSelectedMonth(`${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`);
        return now.toISOString().slice(0, 10); // "YYYY-MM-DD"
    });

    const [selectedDay, setSelectedDay] = useState(() => {
        const now = new Date();
        return now.getDate();
    });

    const [loading, setLoading] = useState(false); // <-- aggiungi stato loading
    const getLocalToday = () => {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
    };
    const [today, setToday] = useState(getLocalToday);
    useEffect(() => {
        // Aggiorna "oggi" se la pagina resta aperta oltre la mezzanotte
        const interval = setInterval(() => setToday(getLocalToday()), 60000);
        return () => clearInterval(interval);
    }, []);
    const [selectedTarget, setSelectedTarget] = useState([{
        name: "",
        fee: 0,
        promo: "",
        isTemp: false,
        tempText: "",
    }]);
    const [selectedUser, setSelectedUser] = useState();
    const [selectedCoop, setSelectedCoop] = useState();
    const [selectedContact, setSelectedContact] = useState();
    const [users, setUsers] = useState([]);
    const [targetItems, setTargetItems] = useState([]);
    const [targetItemsKO, setTargetItemsKO] = useState([]);

    const loadTargets = async (fee, OTC, selectedMonth) => {
        const response = await getTargets(companyID, fee, OTC, selectedMonth);
        return response.data.data.getTargetListing.edges;
    };

    const loadUsers = async () => {
        const response = await getUsers(companyID);
        return response.data.data.getUserListing.edges;
    };

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 20;
    const [totalItems, setTotalItems] = useState(0);

    const loadTargetItems = async (first, after, selectedMonth) => {
        const response = await getTargetItems(companyID, first, after, selectedMonth);
        // Aggiorna il totale se disponibile
        const totalCount = response.data?.data?.getTargetItemListing?.totalCount;
        if (typeof totalCount === "number") {
            setTotalItems(totalCount);
        }
        return response.data.data.getTargetItemListing.edges;
    };

    const loadCurrency = async () => {
        const response = await getCurrency(companyID);
        if (response.data?.data?.getOTCListing?.edges?.length > 0) {
            setCurrency(response.data.data.getOTCListing.edges[0].node);
        }
    };

    // Carica e calcola la somma totale OTC per utente quando apri il modal
    const handleOpenTargetItemsModal = () => {
        loadTargetItems(itemsPerPage, 0, selectedMonth).then(items => {
            setTargetItems(items);
            setCurrentPage(1);
        }).catch(error => {
            console.error("Errore nel caricamento degli item:", error);
        });

        // Carica tutti gli items e calcola la somma totale OTC per utente
        loadAllTargetItems().then(allItems => {
            setTotalOtcSumByUser(getOtcSumByUser(allItems));
            setTotalInsSumByUser(getInsSumByUser(allItems));
            setTotalOtcUnlockedByUser(getOtcSumByUserUnlocked(allItems));
        });
    };

    const handleOpenAddCardModal = () => {
        // Qui puoi caricare eventuali dati necessari per il modal di aggiunta target
    };

    // Gestione cambio pagina
    const handlePageChange = (page) => {
        const after = (page - 1) * itemsPerPage;
        loadTargetItems(itemsPerPage, after, selectedMonth).then(items => {
            setTargetItems(items);
            setCurrentPage(page);
        }).catch(error => {
            console.error("Errore nel caricamento degli item:", error);
        });
    };

    // Calcola il numero totale di pagine
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (window.confirm("Vuoi procedere con la conferma del carrello?")) {
            if (listTargets.length > 0) {
                const formData = new FormData(e.target);
                const message = selectedUser.username + " - " + selectedCoop.username + "\n" +
                    e.target.lastName.value + " " + e.target.firstName.value + "\n" +
                    e.target.companyName.value + "\n" +
                    e.target.phone.value + "\n" +
                    new Date(e.target.dateNotification.value + "T00:00:00").toLocaleDateString("it-IT") + "🔔";
                let targetNames = "";

                // Flusso sequenziale per la gestione del form
                try {
                    // 1. Trova o crea il contatto
                    let contactNode = await getContacts(e.target.fiscalCode.value, companyID).then(contacts => {
                        const contact = contacts.data.data.getContactListing.edges.find(contact =>
                            String(contact.node.fiscalCode).toUpperCase() === String(e.target.fiscalCode.value).toUpperCase()
                        );
                        if (contact) {
                            updateContact(contact.node.id, e.target.phone.value);
                        }
                        return contact ? contact.node.id : null;
                    });

                    // 2. Se il contatto non esiste, crealo
                    if (!contactNode) {
                        const response = await addContact({
                            firstName: e.target.firstName.value,
                            lastName: e.target.lastName.value,
                            phone: e.target.phone.value,
                            fiscalCode: e.target.fiscalCode.value,
                            ...(e.target.companyName.value !== "" ? { companyName: e.target.companyName.value } : {})
                        }, companyID);

                        if (response?.data?.data?.createContact?.output?.id) {
                            contactNode = response.data.data.createContact.output.id;
                            showSuccessToast("Contatto aggiunto con successo!");
                        } else {
                            console.error("Errore: risposta non valida", response);
                            showDangerToast("Errore nel salvataggio del contatto");
                            return;
                        }
                    }

                    // 3. Valida che contactNode sia valido
                    if (!contactNode) {
                        console.error("Errore: contactNode non è valido");
                        showDangerToast("Errore nel salvataggio del contatto");
                        return;
                    }

                    listTargets.forEach(async target => {

                        // 4. Costruisci i dati del target item
                        const plainData = {
                            Target: target.id,
                            User: e.target.User.value,
                            User_coop: e.target.Coop.value,
                            date: e.target.date.value,
                            dateNotification: e.target.dateNotification.value,
                            unlocked: e.target.unlocked.value,
                            status: e.target.status.value,
                            Contact: contactNode
                        };

                        // 5. Costruisci il messaggio da inviare
                        targetNames += "<b>" + target.name + "</b>\n";

                        // 6. Aggiungi il target item
                        const targetResponse = await addTargetItem(plainData, companyID);
                        if (!targetResponse?.data?.data?.createTargetItem?.output?.id) {
                            console.error("Errore: risposta non valida durante l'aggiunta della reward", targetResponse);
                            showDangerToast("Errore nell'aggiunta della reward: ");
                            return;
                        }

                        // 7. Mostra il toast di successo per ogni target aggiunto
                        showSuccessToast("Reward aggiunta con successo!");
                    });

                    // 8. Invia il messaggio
                    await sendMessage(companyID, targetNames + message);

                    // 9. Resetta il form
                    e.target.reset();
                    setListTargets([]);

                } catch (error) {
                    console.error("Errore durante l'aggiunta della reward:", error);
                    showDangerToast("Errore durante l'operazione");
                }
            } else {
                showWarningToast("Seleziona almeno una reward da aggiungere al carrello");
            }
        }
    }

    const handleAddTarget = async (e) => {
        e.preventDefault();

        console.log("Dati del form:", {
            name: e.target.name.value,
            fee: e.target.fee.value,
            promo: e.target.promo.value,
            OTC: e.target.OTC.value,
            Carrier: e.target.Carrier.value,
            TargetType: e.target.TargetType.value,
            visible: e.target.visible.value,
            tempText: e.target.tempText.value,
            isTemp: e.target.tempText.value ? 1 : 0
        });

        // 1. Costruisci i dati del bookmark
        const plainData = {
            name: e.target.name.value.toUpperCase(),
            fee: e.target.fee.value,
            promo: e.target.promo.value,
            OTC: e.target.OTC.value,
            Carrier: e.target.Carrier.value,
            TargetType: e.target.TargetType.value,
            points: e.target.points.value,
            TargetType_points: e.target.TargetType_points.value.split(","),
            visible: e.target.visible.value,
            tempText: e.target.tempText.value,
            isTemp: e.target.tempText.value ? 1 : 0
        };

        console.log("Dati da inviare al server:", plainData);

        // // Replace colons in URL with %3A
        // if (plainData.url.includes(":")) {
        //     plainData.url = plainData.url.replace(/:/g, "%3A");
        // }

        // // 2. Aggiungi la card
        const response = await addTargetCard(plainData, companyID, selectedMonth);
        console.log("Risposta dall'aggiunta della card:", response);

        // // 3. Chiudi la modale
        window.$("#modal-add-card").modal("hide");

        // // 4. Aggiorna la lista dei bookmark
        await fetchData();

        // // 5. Resetta il form
        e.target.reset();
        setThresholds([{ points: "", typeId: "" }]);
    };

    // Funzione per sommare OTC per utente
    const getOtcSumByUser = (items) => {
        const result = {};
        items.forEach(edge => {
            const item = edge.node;
            const username = item.User[0]?.username || "Sconosciuto";
            const otc = Number(item.Target[0]?.fee) || 0;
            if (!result[username]) {
                result[username] = 0;
            }
            result[username] += otc;
        });
        return result;
    };

    // Funzione per sommare inserito per utente
    const getInsSumByUser = (items) => {
        const result = {};
        items.forEach(edge => {
            const item = edge.node;
            const username = item.User_coop[0]?.username || "Sconosciuto";
            const ins = Number(item.Target[0]?.fee) || 0;
            if (!result[username]) {
                result[username] = 0;
            }
            result[username] += ins;
        });
        return result;
    };

    const getOtcSumByUserUnlocked = (items) => {
        const result = {};
        items.forEach(edge => {
            const item = edge.node;
            const username = item.User[0]?.username || "Sconosciuto";
            const otc = Number(item.Target[0]?.fee) || 0;
            const unlocked = item.unlocked === 1 ? "OTC-C" : "OTC-R";
            if (!result[username]) {
                result[username] = { "OTC-C": 0, "OTC-R": 0 };
            }
            result[username][unlocked] += otc;
        });
        return result;
    };

    const loadAllTargetItems = async () => {
        let allItems = [];
        let page = 0;
        let hasMore = true;
        const pageSize = 100; // puoi aumentare se il backend lo permette

        while (hasMore) {
            const items = await getTargetItems(companyID, pageSize, page * pageSize, selectedMonth);
            if (items.data?.data?.getTargetItemListing?.edges?.length > 0) {
                allItems = allItems.concat(items.data.data.getTargetItemListing.edges);
                page++;
                hasMore = items.data.data.getTargetItemListing.edges.length === pageSize;
            } else {
                hasMore = false;
            }
        }
        return allItems;
    };

    const otcSumByUser = getOtcSumByUser(targetItems);

    // Stato per la somma totale OTC per utente
    const [totalOtcSumByUser, setTotalOtcSumByUser] = useState({});
    // Stato per la somma totale INS per utente
    const [totalInsSumByUser, setTotalInsSumByUser] = useState({});

    // Stato per la somma OTC-C e OTC-R per utente
    const [totalOtcUnlockedByUser, setTotalOtcUnlockedByUser] = useState({});

    const fetchTargetItemsKO = async () => {
        const [year, month] = selectedMonth.split("-");
        let y = parseInt(year, 10);
        let m = parseInt(month, 10) - 1;
        if (m === 0) {
            m = 12;
            y -= 1;
        }

        const targetItemsKO = await getTargetItemsKO(companyID, `${y}-${String(m).padStart(2, "0")}`);
        return targetItemsKO;
    };

    // Usa una funzione async per gestire le chiamate asincrone
    const fetchData = async (type = customerType) => {
        try {
            document.querySelector('.right-sidebar').classList.remove('showSidebar');
            document.querySelector('#toggleSidebarBtn').classList.remove('showSidebar');
            const targetItemsKO = await fetchTargetItemsKO();
            setTargetItemsKO(targetItemsKO.data.data.getTargetItemListing.edges);

            setLoading(true); // mostra loader
            // const data3B = await loadTargets(3, 26799, selectedMonth);
            // const data2B = await loadTargets(2, 26799, selectedMonth);
            // const data1B = await loadTargets(1, 26799, selectedMonth);
            // const data3 = await loadTargets(3, 26798, selectedMonth);
            // const data2 = await loadTargets(2, 26798, selectedMonth);
            //const data1 = await loadTargets(1, 26798, selectedMonth);
            const data = await loadTargets(1, type === "business" ? 26799 : 26798, selectedMonth);
            setTargets([data]);
            // setTargets([data1, data2, data3, data1B, data2B, data3B]);
            setLoading(false); // nascondi loader

            const users = await loadUsers();
            setUsers(users);
            // Qui puoi gestire gli utenti caricati, se necessario
        } catch (error) {
            console.error("Errore nel caricamento dei dati:", error);
        }
    };

    const fetchCarriers = async () => {
        const response = await getCarriers(companyID);
        if (response) {
            setCarriers(response.data.data.getCarrierListing.edges);
        }
    }

    useEffect(() => {
        if (companyID) {
            loadUserDetails(user);
            loadCurrency();
            const fetchTargetSettings = async () => {
                const response = await getTargetSettings(companyID, selectedMonth);
                if (response) {
                    setTargetSettings(response.data.data.getTargetSettingListing.edges[0].node);
                }
            }
            fetchTargetSettings();
            const fetchSettings = async () => {
                const response = await getSettings(companyID, "Rewards", selectedMonth);
                if (response) {
                    setSettings(response.data.data.getSettingListing.edges);
                }
            }
            fetchSettings();
            fetchData();
            const fetchTargetTypes = async () => {
                const response = await getTargetTypes(companyID);
                if (response) {
                    setTargetTypes(response.data.data.getTargetTypeListing.edges);
                }
            }
            fetchTargetTypes();
            fetchCarriers();
        }
    }, [selectedMonth, companyID]);

    useEffect(() => {
        setSelectedDay(new Date(selectedDate).getDate()); // Aggiorna selectedDay quando selectedDate cambia
        setSelectedMonth(selectedDate.slice(0, 7)); // Aggiorna selectedMonth quando selectedDate cambia
    }, [selectedDate]); // Ricarica i dati quando cambia il mese

    useEffect(() => {

    }, [listTargets]);

    let color = "";

    // Ref per l'input del date picker
    const dateInputRef = React.useRef(null);

    // Funzione per ottenere il nome del mese in italiano
    const getMonthName = (monthString) => {
        const [year, month] = monthString.split("-");
        const date = new Date(year, month - 1);
        return date.toLocaleString("it-IT", { month: "long", year: "numeric" });
    };

    return (
        <div className="container-fluid">
            {loading ? (
                <div className="text-center my-4">
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            ) : (
                <React.Fragment>
                    <div className="row clearfix justify-content-center mb-10">
                        <div className="col-xl-8 col-12">
                            <div className="card proj-t-card">
                                <div className="card-body">
                                    <div className="d-flex justify-content-center mt-2 row">
                                        <div className="form-group align-items-center mb-2 col-md col-12">
                                            <div className="input-group">
                                                {/* <label className="input-group-text" htmlFor="inputGroupSelect01">
                                                    <span className="material-symbols-outlined" style={{ fontSize: "15px" }}>
                                                        filter_list
                                                    </span>
                                                </label> */}
                                                <select
                                                    className="form-control"
                                                    value={carrierFilter}
                                                    onChange={e => setCarrierFilter(e.target.value)}
                                                >
                                                    <option value="">Tutti gli operatori</option>
                                                    {carriers.map(carrier => (
                                                        <option key={carrier.node.id} value={carrier.node.code}>{carrier.node.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="form-group align-items-center mb-2 col-md col-12">
                                            <div className="input-group">
                                                {/* <label className="input-group-text" htmlFor="inputGroupSelect01">
                                                    <span className="material-symbols-outlined" style={{ fontSize: "15px" }}>
                                                        filter_list
                                                    </span>
                                                </label> */}
                                                <select
                                                    className="form-control"
                                                    value={typeFilter}
                                                    onChange={e => setTypeFilter(e.target.value)}
                                                >
                                                    <option value="">Tutti i tipi</option>
                                                    {targetTypes.map((type, index) => (
                                                        <option key={index} value={type.node.name}>{type.node.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="form-group align-items-center mb-2 col-md col-12">
                                            <div className="input-group">
                                                {/* <label className="input-group-text" htmlFor="inputGroupSelect01">
                                                    <span className="material-symbols-outlined" style={{ fontSize: "15px" }}>
                                                        filter_list
                                                    </span>
                                                </label> */}
                                                <select
                                                    className="form-control"
                                                    value={valueFilter}
                                                    onChange={e => setValueFilter(e.target.value)}
                                                >
                                                    <option value="">Tutte le valenze</option>
                                                    <option value="1">1 PUNTO</option>
                                                    <option value="2">2 PUNTI</option>
                                                    <option value="3">3 PUNTI</option>
                                                    <option value="4">4 PUNTI</option>
                                                    <option value="5">5 PUNTI</option>
                                                    <option value="6">6 PUNTI</option>
                                                    <option value="7">7 PUNTI</option>
                                                    <option value="8">8 PUNTI</option>
                                                    <option value="9">9 PUNTI</option>
                                                    <option value="10">10 PUNTI</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="form-group align-items-center mb-2 col-md col-12">
                                            <div className="input-group">
                                                {/* <label className="input-group-text" htmlFor="inputGroupSelect01">
                                                    <span className="material-symbols-outlined" style={{ fontSize: "15px" }}>
                                                        sort
                                                    </span>
                                                </label> */}
                                                <select
                                                    className="form-control"
                                                    value={sortOrder}
                                                    onChange={e => setSortOrder(e.target.value)}
                                                >
                                                    <option value="code-asc">Codice A-Z</option>
                                                    <option value="code-desc">Codice Z-A</option>
                                                    {/* <option value="carrier-asc">Operatore A-Z</option>
                                                    <option value="carrier-desc">Operatore Z-A</option> */}
                                                    <option value="value-asc">Valore crescente</option>
                                                    <option value="value-desc">Valore decrescente</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="btn-group align-items-center mb-2 col-md col-12">
                                            <div className="btn-group mr-2 mb-3" role="group" aria-label="Tipo cliente">
                                                <button
                                                    type="button"
                                                    className={`btn py-1 ${customerType !== "Business" ? "btn-primary" : "btn-dark"}`}
                                                    aria-pressed={customerType !== "Business"}
                                                    onClick={() => {
                                                        setCustomerType("");
                                                        // if (customerType !== "consumer") fetchData("consumer");
                                                    }}
                                                >
                                                    CNS
                                                </button>
                                                <button
                                                    type="button"
                                                    className={`btn py-1 ${customerType === "Business" ? "btn-primary" : "btn-dark"}`}
                                                    aria-pressed={customerType === "Business"}
                                                    onClick={() => {
                                                        setCustomerType("Business");
                                                        // if (customerType !== "business") fetchData("business");
                                                    }}
                                                >
                                                    BSN
                                                </button>
                                            </div>
                                            <button
                                                type="button"
                                                className="btn btn-secondary py-1 mb-3"
                                                title='Reset filtri'
                                                onClick={() => {
                                                    clearSearch();
                                                    setCarrierFilter("");
                                                    setTypeFilter("");
                                                    setCustomerType("");
                                                    setValueFilter("");
                                                    setSortOrder("value-asc");
                                                }}
                                            >
                                                <span className="material-symbols-outlined" style={{ fontSize: "20px" }}>
                                                    replay
                                                </span>
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-primary ml-2 py-1 mb-3"
                                                title="Ricarica cards"
                                                onClick={() => fetchData()}
                                            >
                                                <span className="material-symbols-outlined" style={{ fontSize: "20px" }}>
                                                    refresh
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row clearfix justify-content-center">
                        {carriers.map((carrier) => (
                            <div key={carrier.node.id || carrier.node.name} className="col-auto mb-3 text-center">
                                <img onClick={() => setCarrierFilter(carrier.node.code)}
                                    src={`${globals.IMAGE_PATH.GENERIC}${carrier && carrier.node.logo.fullpath}`}
                                    className="rounded-circle shadow bg-white p-1 cursor-pointer" height={50} />
                            </div>
                        ))}
                    </div>

                    <div className="row clearfix">
                        <div id='cardsContainer' className="col-lg-12">
                            {targetTypes.map((targetType, typeIndex) => (
                                <React.Fragment key={typeIndex}>
                                    {targets.map((targetList, feeIndex) => (
                                        <React.Fragment key={feeIndex}>
                                            <h1 className="bg-white p-1 text-yellow text-center font-weight-bold" style={{ display: targetList.some(target => target.node.TargetType[0]?.name === targetType.node.name && target.node.name.startsWith(carrierFilter) && (customerType === "Business" ? target.node.TargetType[1]?.name === "Business" : target.node.TargetType[1]?.name !== "Business")) ? "block" : "none" }}>{targetType.node.name.toUpperCase()}</h1>
                                            <div className="row clearfix">
                                                <div className="col-lg-12">
                                                    <div className="row clearfix justify-content-start">
                                                        {targetList
                                                            .sort((a, b) => {
                                                                a = a.node;
                                                                b = b.node;
                                                                switch (sortOrder) {
                                                                    case "carrier-asc":
                                                                    case "carrier-desc":
                                                                        const carrierA = a.Carrier[0].name;
                                                                        const carrierB = b.Carrier[0].name;
                                                                        return sortOrder === "carrier-asc"
                                                                            ? carrierA.localeCompare(carrierB, "it", { sensitivity: "base" })
                                                                            : carrierB.localeCompare(carrierA, "it", { sensitivity: "base" });
                                                                    case "code-asc":
                                                                    case "code-desc":
                                                                        const codeA = a.name;
                                                                        const codeB = b.name;
                                                                        return sortOrder === "code-asc"
                                                                            ? codeA.localeCompare(codeB, "it", { sensitivity: "base" })
                                                                            : codeB.localeCompare(codeA, "it", { sensitivity: "base" });
                                                                    case "value-asc":
                                                                    case "value-desc":
                                                                        const valueA = a.fee;
                                                                        const valueB = b.fee;
                                                                        return sortOrder === "value-asc" ? valueA - valueB : valueB - valueA;
                                                                    default:
                                                                        return null;
                                                                }
                                                            })
                                                            .filter(target => {
                                                                target = target.node;
                                                                // Filtro operatore
                                                                if (carrierFilter && !target.name.startsWith(carrierFilter)) {
                                                                    return false;
                                                                }
                                                                // Filtro valenza
                                                                if (valueFilter && target.fee !== parseInt(valueFilter)) {
                                                                    return false;
                                                                }
                                                                // Filtro tipo
                                                                if (typeFilter && target.TargetType[0]?.name !== typeFilter) {
                                                                    return false;
                                                                }
                                                                // Filtro tipo cliente: Consumer es la selezione predefinita e nasconde i Business
                                                                if (customerType === "Business" && target.TargetType[1]?.name !== "Business") {
                                                                    return false;
                                                                }
                                                                if (customerType !== "Business" && target.TargetType[1]?.name === "Business") {
                                                                    return false;
                                                                }
                                                                // Filtro ricerca
                                                                if (searchTerm) {
                                                                    const term = searchTerm.toLowerCase();
                                                                    const fullName = `${target.name} ${target.promo}`.toLowerCase();
                                                                    if (
                                                                        !fullName.includes(term)
                                                                    ) {
                                                                        return false;
                                                                    }
                                                                }
                                                                return true;
                                                            })
                                                            .map((target, index) => {
                                                                target = target.node;
                                                                color = target.fee === 3 ? "dark" : target.fee === 2 ? "primary" : "green";
                                                                if (targetType.node.name == target.TargetType[0].name) {
                                                                    return (
                                                                        <div key={index} {...(!isEditable && !isDeletable && { onClick: () => { setListTargets([...listTargets, target]); showInfoToast(`Reward ${target.name} aggiunta al carrello`); } })} className="col-md-auto col-sm-12">
                                                                            <div className={`card proj-t-card cursor-pointer ${isEditable ? 'bg-secondary text-light' : isDeletable ? 'bg-danger text-light' : ''}`}>
                                                                                <div className="card-body">
                                                                                    <div className="row align-items-center mb-0">
                                                                                        {/* LOGO COIN */}
                                                                                        <div className="col text-center">
                                                                                            <span className="d-inline-flex align-items-center justify-content-center font-weight-bold text-yellow" style={{ fontSize: "2rem" }}>{target.fee}</span>
                                                                                        </div>
                                                                                        {/* NOME TARGET */}
                                                                                        <div className="col m-0 p-0">
                                                                                            <h6 className={`mb-0 text-center`}>{target.name && target.name.charAt(0).toUpperCase() + target.name.slice(1)}</h6>
                                                                                            {target.isTemp ?
                                                                                                <div className={`badge badge-danger text-uppercase temp-text p-1 mx-auto d-block`} style={{ display: "block", width: "fit-content" }}>
                                                                                                    {target.tempText && target.tempText.charAt(0).toUpperCase() + target.tempText.slice(1)}
                                                                                                </div>
                                                                                                : null
                                                                                            }
                                                                                        </div>
                                                                                        <div className="col"></div>
                                                                                    </div>
                                                                                    <div className="row align-items-center text-center">
                                                                                        <div className="col">
                                                                                            <h6 className="mb-0 pl-1">
                                                                                                {target.TargetType.map((type, typeIndex) => (
                                                                                                    <React.Fragment key={typeIndex}>
                                                                                                        <span className="mr-1">
                                                                                                            {type.name && type.name.charAt(0).toUpperCase() + type.name.slice(1)}
                                                                                                        </span>
                                                                                                    </React.Fragment>
                                                                                                ))}
                                                                                            </h6>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="row align-items-center text-center">
                                                                                        {target.promo
                                                                                            ? target.promo.split('\n').map((line, i) => (
                                                                                                <React.Fragment key={i}>
                                                                                                    <div className="col">
                                                                                                        <div key={i} className="mb-0 target-promo text-uppercase">{line && line.charAt(0).toUpperCase() + line.slice(1)}</div>
                                                                                                    </div>
                                                                                                </React.Fragment>
                                                                                            ))
                                                                                            : null}
                                                                                    </div>
                                                                                    <div style={{ position: "absolute", bottom: "2px", right: "2px" }}>
                                                                                        {isEditable &&
                                                                                            <span className="material-symbols-outlined text-light cursor-pointer m-0 p-0" title="Modifica card" onClick={() => { showInfoToast("Funzionalità in sviluppo"); }}>
                                                                                                edit
                                                                                            </span>
                                                                                        }
                                                                                    </div>
                                                                                    <div style={{ position: "absolute", bottom: "2px", right: "2px" }}>
                                                                                        {isDeletable &&
                                                                                            <span className="material-symbols-outlined text-light cursor-pointer m-0 p-0" title="Elimina card" onClick={() => {
                                                                                                if (window.confirm(`Sei sicuro di voler eliminare la reward ${target.name}?`)) {
                                                                                                    updateTargetCard(target.id, { visible: 0 }).then(() => {
                                                                                                        fetchData();
                                                                                                        showSuccessToast(`Reward ${target.name} eliminata con successo!`);
                                                                                                        setIsDeletable(false);
                                                                                                    });
                                                                                                }
                                                                                            }}>
                                                                                                delete
                                                                                            </span>
                                                                                        }
                                                                                    </div>
                                                                                    <h6 className={`pt-badge bg-light text-center`}>
                                                                                        <img src={`${globals.IMAGE_PATH.GENERIC}${target.Carrier && target.Carrier[0].logo.fullpath}`} className="rounded-circle shadow bg-white p-1" height={50} />
                                                                                    </h6>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                }
                                                            })}
                                                    </div>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    ))}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                </React.Fragment>
            )
            }

            <Rightbar listTargets={listTargets ? listTargets : []} rewards=
                {(
                    <div className="shoppingCart card proj-t-card">
                        <div className="card-body">
                            <h6 className="mb-3">Carrello {new Date(selectedDate + "T00:00:00").toLocaleDateString("it-IT")}</h6>
                            {selectedDate !== today && (
                                <div className="alert alert-warning font-weight-bold mb-3" role="alert">
                                    <i className="material-symbols-outlined align-middle mr-1">warning</i>
                                    Attenzione: la data del carrello ({new Date(selectedDate + "T00:00:00").toLocaleDateString("it-IT")}) è diversa da quella odierna ({new Date(today + "T00:00:00").toLocaleDateString("it-IT")}). Puoi cambiarla dal calendario.
                                </div>
                            )}
                            <form className="forms-sample" method="post" onSubmit={handleSubmit}>
                                <input type="hidden" name="Target" value={selectedTarget.id} />
                                <input type="hidden" name="Contact" value={selectedContact && selectedContact.id} />
                                <input type="hidden" name="unlocked" value={0} />
                                <input type="hidden" name="status" value={0} />
                                <input type="hidden" name="date" value={selectedDate} />

                                <div className="row">
                                    <div className="col-6">
                                        <div className="form-group">
                                            <select className="form-control" id="userID" name="User" defaultValue={""} required
                                                onChange={async (e) => {
                                                    setSelectedUser(users.find(u => u.node.id === e.target.value).node);
                                                }}>
                                                <option value="">Venduto</option>
                                                {users.map((user, index) => (
                                                    <option key={index} value={user.node.id}>
                                                        {user.node.username}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="form-group">
                                            <select className="form-control" id="coopID" name="Coop" defaultValue={""} required
                                                onChange={async (e) => {
                                                    setSelectedCoop(users.find(u => u.node.id === e.target.value).node);
                                                }}>
                                                <option value="">Inserito</option>
                                                {users.map((user, index) => (
                                                    <option key={index} value={user.node.id}>
                                                        {user.node.username}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <hr className="mt-0 mb-2" />
                                <h6>Dati cliente</h6>
                                <div className="row">
                                    <div className="col-6">
                                        <div className="form-group">
                                            <input type="text" className="form-control form-control-sm" id="lastName" name="lastName" placeholder="Cognome" required />
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="form-group">
                                            <input type="text" className="form-control form-control-sm" id="firstName" name="firstName" placeholder="Nome" required />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <input type="text" className="form-control form-control-sm" id="companyName" name="companyName" placeholder="Ragione Sociale" />
                                        </div>
                                    </div>
                                    <div className="col-5 pr-1">
                                        <div className="form-group">
                                            <input type="text" className="form-control form-control-sm" id="phone" name="phone" placeholder="Telefono" required />
                                        </div>
                                    </div>
                                    <div className="col-7 pl-1">
                                        <div className="form-group">
                                            <input type="text" className="form-control form-control-sm" id="fiscalCode" name="fiscalCode" placeholder="Codice Fiscale/P. IVA" required />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <div className="input-group notification-group">
                                                <div className="input-group-prepend">
                                                    <div className="dropdown">
                                                        <button className="input-group-text bg-warning text-white dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                            <span className="material-symbols-outlined p-0" style={{ fontSize: "20px" }}>
                                                                notifications
                                                            </span>
                                                        </button>
                                                        <div className="dropdown-menu rewards-notification-dropdown" aria-labelledby="dropdownMenuButton">
                                                            <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); const d = new Date(selectedDate); d.setMonth(d.getMonth() + 1); document.getElementById('dateNotification').value = d.toISOString().slice(0, 10); }}>Notifica tra 1 mese</a>
                                                            <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); const d = new Date(selectedDate); d.setMonth(d.getMonth() + 2); document.getElementById('dateNotification').value = d.toISOString().slice(0, 10); }}>Notifica tra 2 mesi</a>
                                                            <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); const d = new Date(selectedDate); d.setMonth(d.getMonth() + 3); document.getElementById('dateNotification').value = d.toISOString().slice(0, 10); }}>Notifica tra 3 mesi</a>
                                                            <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); const d = new Date(selectedDate); d.setMonth(d.getMonth() + 4); document.getElementById('dateNotification').value = d.toISOString().slice(0, 10); }}>Notifica tra 4 mesi</a>
                                                            <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); const d = new Date(selectedDate); d.setMonth(d.getMonth() + 5); document.getElementById('dateNotification').value = d.toISOString().slice(0, 10); }}>Notifica tra 5 mesi</a>
                                                            <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); const d = new Date(selectedDate); d.setMonth(d.getMonth() + 6); document.getElementById('dateNotification').value = d.toISOString().slice(0, 10); }}>Notifica tra 6 mesi</a>
                                                            <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); const d = new Date(selectedDate); d.setMonth(d.getMonth() + 9); document.getElementById('dateNotification').value = d.toISOString().slice(0, 10); }}>Notifica tra 9 mesi</a>
                                                            <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); const d = new Date(selectedDate); d.setMonth(d.getMonth() + 12); document.getElementById('dateNotification').value = d.toISOString().slice(0, 10); }}>Notifica tra 12 mesi</a>
                                                            <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); const d = new Date(selectedDate); d.setMonth(d.getMonth() + 18); document.getElementById('dateNotification').value = d.toISOString().slice(0, 10); }}>Notifica tra 18 mesi</a>
                                                            <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); const d = new Date(selectedDate); d.setMonth(d.getMonth() + 24); document.getElementById('dateNotification').value = d.toISOString().slice(0, 10); }}>Notifica tra 24 mesi</a>
                                                            <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); const d = new Date(selectedDate); d.setMonth(d.getMonth() + 30); document.getElementById('dateNotification').value = d.toISOString().slice(0, 10); }}>Notifica tra 30 mesi</a>
                                                            <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); const d = new Date(selectedDate); d.setMonth(d.getMonth() + 36); document.getElementById('dateNotification').value = d.toISOString().slice(0, 10); }}>Notifica tra 36 mesi</a>
                                                            <a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); const d = new Date(selectedDate); d.setMonth(d.getMonth() + 48); document.getElementById('dateNotification').value = d.toISOString().slice(0, 10); }}>Notifica tra 48 mesi</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <input type="date" className="form-control" id="dateNotification" name="dateNotification" placeholder="Data notifica" required />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr className="mt-0 mb-2" />
                                <div className="row font-weight-bold">
                                    <div className="col-6">
                                        <div className="form-group mb-0">
                                            <label htmlFor={`target`}>Codice</label>
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="form-group mb-0">
                                            <label htmlFor={`value`}>Valore</label>
                                        </div>
                                    </div>
                                    <div className="col-2 text-right">
                                    </div>
                                </div>
                                <hr className="mt-0 mb-2" />
                                <div className="row cart-list">
                                    <div className="col-12">
                                        {listTargets && listTargets.length > 0 ? (
                                            listTargets.map((target, index) => (
                                                <React.Fragment key={index}>
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <small>{index + 1}. {target.name}</small>
                                                        </div>
                                                        <div className="col-4 text-center">
                                                            <small>{target.fee}</small>
                                                        </div>
                                                        <div className="col-2 text-right">
                                                            <button type="button" className="btn btn-sm text-danger py-1 px-0 mx-0" title="Elimina reward" onClick={() => {
                                                                setListTargets(listTargets.filter((_, i) => i !== index));
                                                                showInfoToast(`<b>${target.name}</b> rimossa dal carrello`);
                                                            }}>
                                                                <span className="material-symbols-outlined" style={{ fontSize: "20px" }}>
                                                                    delete
                                                                </span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <hr className="my-1" />
                                                </React.Fragment>
                                            ))
                                        ) : (
                                            <React.Fragment>
                                                <div className="row">
                                                    <div className="col-6">
                                                        <small>Il carrello è vuoto</small>
                                                    </div>
                                                </div>
                                                <hr />
                                            </React.Fragment>
                                        )}
                                    </div>
                                </div>
                                <div className="row cart-total py-3">
                                    <div className="col-12">
                                        <h6>Totale</h6>
                                    </div>
                                    <div className="col-12">
                                        <div className="input-group cart-total-group mb-3">
                                            <div className="input-group-prepend">
                                                <button type="button" className="btn btn-sm text-danger btn-light p-1" title="Svuota carrello" onClick={() => {
                                                    if (window.confirm("Vuoi svuotare il carrello?")) {
                                                        setListTargets([]);
                                                        showSuccessToast("Carrello svuotato");
                                                    }
                                                }}>
                                                    <span className="material-symbols-outlined" style={{ fontSize: "20px" }}>
                                                        shopping_cart_off
                                                    </span>
                                                </button>
                                            </div>
                                            <input type="text" className="form-control text-right" id="totalValue" name="totalValue" value={listTargets.reduce((sum, target) => sum + target.fee, 0)} readOnly />
                                            <div className="input-group-append">
                                                <button type="submit" className="btn btn-primary px-1" title="Conferma vendita">
                                                    <span className="material-symbols-outlined" style={{ fontSize: "20px" }}>
                                                        check
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
            />

            {/* MODAL ADD TARGET CARD */}
            <div className="modal fade" id="modal-add-card" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalCenterTitle">Aggiungi card Rewards</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card-body">
                                        <form className="forms-sample" method="post" onSubmit={handleAddTarget}>
                                            <input type="hidden" id="OTC" name="OTC" value={currency && currency.id} />
                                            <input type="hidden" id="visible" name="visible" value="1" />
                                            <input type="hidden" className="form-control" name="points" value={thresholds.map(threshold => threshold.points).join("-")} />
                                            <input type="hidden" name="TargetType_points" value={thresholds.map(threshold => threshold.typeId).join(",")} />

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Nome</label>
                                                        <input type="text" className="form-control" id="name" name="name" maxLength="16" required />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Highlight</label>
                                                        <input type="text" className="form-control" id="tempText" name="tempText" maxLength="32" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="form-group">
                                                        <label>Descrizione</label>
                                                        <input type="text" className="form-control" id="promo" name="promo" maxLength="64" required />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Operatore</label>
                                                        <select required
                                                            className="form-control"
                                                            id="Carrier" name="Carrier"
                                                        >
                                                            <option value=""></option>
                                                            {carriers.map(carrier => (
                                                                <option key={carrier.node.id} value={carrier.node.id}>{carrier.node.name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Punti rewards</label>
                                                        <input type="number" className="form-control" id="fee" name="fee" min="0.1" max="10" step="0.1" />
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-12">
                                                    <div className="form-group">
                                                        <label>Tipologia</label>
                                                        <select required
                                                            className="form-control"
                                                            id="TargetType" name="TargetType"
                                                        >
                                                            <option value=""></option>
                                                            {targetTypes.map((type, index) => (
                                                                <option key={index} value={type.node.id}>{type.node.name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-6">
                                                    <div className="form-group m-0 p-0">
                                                        <label>Punti soglia</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-6">
                                                    <div className="form-group m-0 p-0">
                                                        <label>Tipo soglia</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-6"></div>
                                                {thresholds.map((threshold, index) => (
                                                    <React.Fragment key={index}>
                                                        <div className="col-md-4 col-6">
                                                            <div className="form-group">
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    min="0.1"
                                                                    max="10"
                                                                    step="0.01"
                                                                    required
                                                                    value={threshold.points}
                                                                    onChange={e => setThresholds(current => current.map((item, i) => i === index ? { ...item, points: e.target.value } : item))}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 col-6">
                                                            <div className="form-group">
                                                                <select
                                                                    required
                                                                    className="form-control"
                                                                    value={threshold.typeId}
                                                                    onChange={e => setThresholds(current => current.map((item, i) => i === index ? { ...item, typeId: e.target.value } : item))}
                                                                >
                                                                    <option value=""></option>
                                                                    {targetTypes.map((type, typeIndex) => (
                                                                        <option key={typeIndex} value={type.node.id}>{type.node.name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        {thresholds.length > 1 && (
                                                            <div className="col-md-1 col-12 d-flex align-items-start">
                                                                <button type="button" className="btn text-danger px-0 py-1" aria-label="Rimuovi soglia" onClick={() => setThresholds(current => current.filter((_, i) => i !== index))}>
                                                                    <span class="material-symbols-outlined">
                                                                        delete_forever
                                                                    </span>
                                                                </button>
                                                            </div>
                                                        )}
                                                    </React.Fragment>
                                                ))}
                                                <div className="col-12 mb-2">
                                                    <button type="button" className="btn text-success p-0" onClick={() => { setThresholds(current => [...current, { points: "", typeId: "" }]); console.log("Soglia aggiunta"); console.log(thresholds); }}>
                                                        <span className="material-symbols-outlined">
                                                            add_circle
                                                        </span>
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-md-12 text-right">
                                                    <button type="button" className="btn btn-light mr-2" data-dismiss="modal">Annulla</button>
                                                    <button type="submit" className="btn btn-primary">Conferma</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* MODAL GET TARGET ITEM */}
            <div className="modal fade w-100" id="modal-get-targetItems" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalCenterTitle">Rewards {getMonthName(selectedMonth).charAt(0).toUpperCase() + getMonthName(selectedMonth).slice(1)}</h5>
                            <button type="button" className="close rewards-modal-close" data-dismiss="modal" aria-label="Close">
                                <span className="material-symbols-outlined" aria-hidden="true">cancel</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row mt-4">
                                <div className="col-12">
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover rounded month-table" style={{ background: "#fff" }}>
                                            <thead className="thead-dark">
                                                <tr>
                                                    <th
                                                        className="text-center align-middle"
                                                        style={{
                                                            background: "#ffffff",
                                                            color: "#007bff",
                                                            width: "10%",
                                                            minWidth: 80,
                                                            maxWidth: 120,
                                                            border: "none",
                                                            fontWeight: 600,
                                                            fontSize: "1.1em",
                                                        }}
                                                    ></th>
                                                    {[...Array(4)].map((_, i) => (
                                                        <th
                                                            key={i}
                                                            className="text-center align-middle"
                                                            style={{
                                                                width: "15%",
                                                                minWidth: 80,
                                                                maxWidth: 140,
                                                            }}
                                                        >
                                                            {["Premi", "KO", "Inserito", "Venduto"][i]}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {[...users]
                                                    .map(user => user.node)
                                                    .sort((a, b) => a.username.localeCompare(b.username, "it", { sensitivity: "base" }))
                                                    .map(userNode => (
                                                        <tr key={userNode.username} style={{ display: userNode.username === "FED" ? "none" : "" }}>
                                                            <td
                                                                className="text-center align-middle font-weight-bold bg-dark text-white"
                                                                style={{
                                                                    fontSize: "1.1em",
                                                                    background: "#f2f2f2",
                                                                    color: "#ffffff",
                                                                    fontWeight: 600,
                                                                    width: "10%",
                                                                    minWidth: 80,
                                                                    maxWidth: 120,
                                                                }}
                                                            >
                                                                {userNode.username}<br />
                                                                ({(targetSettings.minOTC * userNode.percentage / 100)}-{(targetSettings.extraOTC * userNode.percentage / 100)})
                                                            </td>
                                                            {/* Colonna €-C */}
                                                            <td className="text-center align-middle text-primary" style={{ fontSize: "1.1em", color: "#f2f2f2", fontWeight: 600, width: "15%", minWidth: 80, maxWidth: 140 }}>
                                                                {settings && settings.length > 0
                                                                    ? (() => {
                                                                        let prize = "";
                                                                        settings.forEach((field, i) => {
                                                                            const qty = Number(field.node.qty) || 0;
                                                                            const val = Number(field.node.val) || 0;
                                                                            const name = field.node.name || "";
                                                                            if (qty === 0) {
                                                                                return prize = `${(totalOtcUnlockedByUser[userNode.username]?.["OTC-C"] || 0) * val}`;
                                                                            }
                                                                            const total = totalOtcSumByUser[userNode.username] || 0;
                                                                            if (total >= qty) {
                                                                                prize = val;
                                                                            }
                                                                            if (prize == "") {
                                                                                prize = 0;
                                                                            }
                                                                        });
                                                                        return userNode.username === "TIZ" ? "" : prize;
                                                                    })()
                                                                    : null
                                                                }


                                                            </td>
                                                            {/* Colonna €-KO */}
                                                            <td className="text-center align-middle text-danger" style={{ fontSize: "1.1em", color: "#f2f2f2", fontWeight: 600, width: "15%", minWidth: 80, maxWidth: 140 }}>
                                                                {targetItemsKO && targetItemsKO.length > 0
                                                                    ? targetItemsKO
                                                                        .filter(item => item.node.User[0]?.username === userNode.username)
                                                                        .reduce((sum, item) => {
                                                                            const fee = Number(item.node.Target[0]?.fee) || 0;
                                                                            const multiplier = item.node.unlocked === 1 ? 5 : 0;
                                                                            return sum + (fee * multiplier);
                                                                        }, 0)
                                                                    : 0}
                                                            </td>
                                                            {/* Colonna Inserito */}
                                                            <td className="text-center align-middle text-dark" style={{ fontSize: "1.1em", color: "#f2f2f2", fontWeight: 600, width: "15%", minWidth: 80, maxWidth: 140 }}>
                                                                {totalInsSumByUser[userNode.username] || 0}
                                                            </td>
                                                            {/* Colonna OTC totale */}
                                                            <td className={`text-center align-middle ${totalOtcSumByUser[userNode.username] >= (targetSettings.minOTC * userNode.percentage / 100) ? "text-success" : "text-dark"}`} style={{ fontSize: "1.1em", color: "#f2f2f2", fontWeight: 600, width: "15%", minWidth: 80, maxWidth: 140 }}>
                                                                {totalOtcSumByUser[userNode.username] || 0}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                <tr className="font-weight-bold bg-primary text-white">
                                                    <td className="text-center align-middle">Totale</td>
                                                    <td className="text-center align-middle">
                                                        {
                                                            settings && settings.length > 0
                                                                ? users
                                                                    .map(user => user.node.username)
                                                                    .reduce((sum, username) => {
                                                                        let prize = 0;
                                                                        settings.forEach((field) => {
                                                                            const qty = Number(field.node.qty) || 0;
                                                                            const val = Number(field.node.val) || 0;
                                                                            if (qty === 0) {
                                                                                prize += (totalOtcUnlockedByUser[username]?.["OTC-C"] || 0) * val;
                                                                            } else {
                                                                                const total = totalOtcSumByUser[username] || 0;
                                                                                if (total >= qty) {
                                                                                    prize += val;
                                                                                }
                                                                            }
                                                                        });
                                                                        return sum + prize;
                                                                    }, 0)
                                                                : 0
                                                        }
                                                    </td>
                                                    {/* <td className="text-center align-middle">
                                                        {
                                                            users
                                                                .map(user => user.node.username)
                                                                .reduce((sum, username) => sum + ((totalOtcUnlockedByUser[username]?.["OTC-R"] || 0) * 1), 0)
                                                        }
                                                    </td> */}
                                                    <td className="text-center align-middle">
                                                        {
                                                            users
                                                                .map(user => user.node.username)
                                                                .reduce((sum, username) => sum + (
                                                                    targetItemsKO && targetItemsKO.length > 0
                                                                        ? targetItemsKO
                                                                            .filter(item => item.node.User[0]?.username === username)
                                                                            .reduce((subSum, item) => {
                                                                                const fee = Number(item.node.Target[0]?.fee) || 0;
                                                                                const multiplier = item.node.unlocked === 1 ? 5 : 0;
                                                                                return subSum + (fee * multiplier);
                                                                            }, 0)
                                                                        : 0
                                                                ), 0)
                                                        }
                                                    </td>
                                                    {/* <td className="text-center align-middle">
                                                        {
                                                            users
                                                                .map(user => user.node.username)
                                                                .reduce((sum, username) => sum + (totalOtcUnlockedByUser[username]?.["OTC-C"] || 0), 0)
                                                        } / {targetSettings ? targetSettings.tgtOTC : ""}
                                                    </td> */}
                                                    {/* <td className="text-center align-middle">
                                                        {
                                                            users
                                                                .map(user => user.node.username)
                                                                .reduce((sum, username) => sum + (totalOtcUnlockedByUser[username]?.["OTC-R"] || 0), 0)
                                                        }
                                                    </td> */}
                                                    <td className="text-center align-middle">
                                                        {
                                                            users
                                                                .map(user => user.node.username)
                                                                .reduce((sum, username) => sum + (totalInsSumByUser[username] || 0), 0)
                                                        } / {targetSettings ? targetSettings.tgtOTC : ""}
                                                    </td>
                                                    <td className="text-center align-middle">
                                                        {
                                                            users
                                                                .map(user => user.node.username)
                                                                .reduce((sum, username) => sum + (totalOtcSumByUser[username] || 0), 0)
                                                        } / {targetSettings ? targetSettings.tgtOTC : ""}
                                                    </td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td className="border-0 bg-white"></td>
                                                    <td className="shadow-sm">Premi in € sbloccati</td>
                                                    <td className="shadow-sm">KO del mese precedente</td>
                                                    <td className="shadow-sm">Inserimenti totali</td>
                                                    <td className="shadow-sm">Coin totali guadagnati</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-12">
                                    {/* MOBILE FRIENDLY LISTA TARGET ITEM */}
                                    <div className="d-flex flex-column gap-2">
                                        {targetItems && targetItems.length > 0 ? (
                                            targetItems.map((item, index) => {
                                                item = item.node;
                                                const unlocked = item.unlocked === 1;
                                                // Assegna il colore ma non stamparlo
                                                color = item.Target[0].fee === 3 ? "dark" : item.Target[0].fee === 2 ? "primary" : "green";
                                                // Calcola l'indice in ordine decrescente
                                                const descendingIndex = totalItems - ((currentPage - 1) * itemsPerPage + index);
                                                return (
                                                    <div
                                                        key={index}
                                                        className={`card mb-2 shadow-sm target-item-card ${unlocked ? "border-success is-unlocked" : "border-dark"}`}
                                                        style={{
                                                            borderLeft: unlocked ? "5px solid #28a745" : "5px solid #1c1c1c",
                                                            cursor: "pointer",
                                                            opacity: unlocked ? 1 : 0.85,
                                                            background: unlocked ? "#eafaf1" : "#fff"
                                                        }}
                                                    >
                                                        <div className="card-body p-2">
                                                            <div className="d-flex justify-content-between align-items-center mb-1">
                                                                <div className="d-flex align-items-center">
                                                                    <span className={`badge badge-${itemStatus[item.status].color} mr-2`} style={{ minWidth: 28 }}>{descendingIndex}</span>
                                                                    <span className={`badge text-white badge-${color} mr-2`}><strong>{item.Target[0].name}</strong></span>
                                                                    <span className="badge badge-info">
                                                                        {item.Target[0].fee}{" "}
                                                                        {/* <span style={{ fontSize: 12 }}>
                                                                            {unlocked ? "OTC-C" : "OTC-R"}
                                                                        </span> */}
                                                                    </span>
                                                                </div>
                                                                {userDetails && userDetails.role == 0 ? (
                                                                    <div>
                                                                        <span
                                                                            title={unlocked ? "Clicca per bloccare" : "Clicca per sbloccare"}
                                                                            onClick={async () => {
                                                                                const newUnlocked = unlocked ? 0 : 1;
                                                                                await updateTargetItemUnlocked(item.id, newUnlocked);
                                                                                setTargetItems(prev =>
                                                                                    prev.map((edge, i) =>
                                                                                        i === index
                                                                                            ? { ...edge, node: { ...edge.node, unlocked: newUnlocked } }
                                                                                            : edge
                                                                                    )
                                                                                );
                                                                                const allItems = await loadAllTargetItems();
                                                                                setTotalOtcSumByUser(getOtcSumByUser(allItems));
                                                                                setTotalOtcUnlockedByUser(getOtcSumByUserUnlocked(allItems));
                                                                            }}
                                                                            style={{
                                                                                fontSize: 13,
                                                                                color: unlocked ? "#28a745" : "#888",
                                                                                fontWeight: 600
                                                                            }}
                                                                        >
                                                                            {unlocked ? "Sbloccato" : "Bloccato"}
                                                                        </span>
                                                                    </div>) : ""}
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-6">
                                                                    <div style={{ fontSize: 13 }}>
                                                                        <strong>Data:</strong> {new Date(item.date).toLocaleDateString("it-IT")}
                                                                    </div>
                                                                    <div style={{ fontSize: 13 }}>
                                                                        <strong>Venduto da:</strong> {item.User[0].username}
                                                                    </div>
                                                                    <div style={{ fontSize: 13 }}>
                                                                        <strong>Inserito da:</strong> {item.User_coop ? item.User_coop[0].username : item.User[0].username}
                                                                    </div>
                                                                </div>
                                                                <div className="col-6">
                                                                    <div style={{ fontSize: 13 }}>
                                                                        <strong>Cognome:</strong> {item.Contact[0].lastName.toUpperCase()}
                                                                    </div>
                                                                    <div style={{ fontSize: 13 }}>
                                                                        <strong>Nome:</strong> {item.Contact[0].firstName.toUpperCase()}
                                                                    </div>
                                                                    <div style={{ fontSize: 13 }}>
                                                                        <strong>CF/P.IVA:</strong> {item.Contact[0].fiscalCode?.toUpperCase()}
                                                                    </div>
                                                                    <div style={{ fontSize: 13 }}>
                                                                        <strong>Ragione Sociale:</strong> {item.Contact[0].companyName?.toUpperCase()}
                                                                    </div>
                                                                    <div style={{ fontSize: 13 }}>
                                                                        <strong>Telefono:</strong> {item.Contact[0].phone}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        ) : (
                                            <div className="text-center text-muted py-4">Nessun target item trovato.</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <nav className="rewards-pagination-nav" aria-label="Paginazione lista premi">
                                <ul className="pagination rewards-pagination mb-0">
                                    <li className={`page-item page-first ${currentPage === 1 ? "disabled" : ""}`}>
                                        <a className="page-link first" href="#" onClick={e => { e.preventDefault(); handlePageChange(1); }}>
                                            <i className="ik ik-chevrons-left"></i>
                                        </a>
                                    </li>
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <a className="page-link prev" href="#" onClick={e => { e.preventDefault(); handlePageChange(currentPage - 1); }}>
                                            <i className="ik ik-chevron-left"></i>
                                        </a>
                                    </li>
                                    {/* Mostra massimo 5 pagine */}
                                    {Array.from({ length: totalPages }, (_, i) => i + 1)
                                        .slice(
                                            Math.max(0, currentPage - 3),
                                            Math.min(totalPages, currentPage + 2)
                                        )
                                        .map(page => (
                                            <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
                                                <a className="page-link" href="#" onClick={e => { e.preventDefault(); handlePageChange(page); }}>
                                                    {page}
                                                </a>
                                            </li>
                                        ))}
                                    <li className={`page-item page-next ${currentPage === totalPages ? "disabled" : ""}`}>
                                        <a className="page-link next" href="#" aria-label="Next" onClick={e => { e.preventDefault(); handlePageChange(currentPage + 1); }}>
                                            <i className="ik ik-chevron-right"></i>
                                        </a>
                                    </li>
                                    <li className={`page-item page-last ${currentPage === totalPages ? "disabled" : ""}`}>
                                        <a className="page-link last" href="#" onClick={e => { e.preventDefault(); handlePageChange(totalPages); }}>
                                            <i className="ik ik-chevrons-right"></i>
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <FooterBar
                footerIcon={"trophy"}
                footerTitle={`Rewards`}
                footerButton={
                    <React.Fragment>
                        {userDetails && userDetails.role <= 1 && (
                            <>
                                <FooterButton icon="add" title="Aggiungi card" action={handleOpenAddCardModal} target="#modal-add-card" />
                                <FooterButton icon="edit" title="Modifica card" action={() => { setIsEditable(!isEditable); setIsDeletable(false); }} />
                                <FooterButton icon="delete" title="Elimina card" action={() => { setIsEditable(false); setIsDeletable(!isDeletable); }} />
                            </>
                        )}
                        <FooterButton icon="lists" title="Lista del mese" action={handleOpenTargetItemsModal} target="#modal-get-targetItems" />
                    </React.Fragment>
                }
                footerPlugin={<Calendar selectedDate={selectedDate} setSelectedDate={setSelectedDate} />}
            />
        </div >
    );
};
export default Rewards;